import { useState } from "react";
import DashboardService from "../../services/DashboardService";

const statsInitial = {
    year: new Date().getFullYear(),
    totalTrainingsInYear: 0,
    trainingsByMonth: [],
    pastTrainings: 0,
    activeTrainings: 0,
    futureTrainings: 0,
    pastTrainingsParticipants: 0,
    activeTrainingsParticipants: 0,
    futureTrainingsParticipants: 0,
}

function createData(response) {

    if (response == null) return null;

    return {
        year: response.year,
        totalTrainingsInYear: response.totalTrainingsInYear,
        trainingsByMonth: response.trainingsByMonth ?? [],
        pastTrainings: response.pastTrainings,
        activeTrainings: response.activeTrainings,
        futureTrainings: response.futureTrainings,
        pastTrainingsParticipants: response.pastTrainingsParticipants,
        activeTrainingsParticipants: response.activeTrainingsParticipants,
        futureTrainingsParticipants: response.futureTrainingsParticipants,
    };
}

const useMainContainer = () => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState(statsInitial);

    const getStats = async (year) => {
        const response = await DashboardService.getStats(year);
        const data = createData(response) ?? statsInitial;
        setStats(data);
        setLoading(false);
    };

    return {
        loading,
        stats,
        getStats,
    }
};

export default useMainContainer;
